export default "__VITE_ASSET__2245161b__"